import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalRoot } from './root';
import { ModalBackdrop } from './backdrop';
import { ModalPanel } from './panel';
import { ModalHeader } from './header';
import { ModalContent } from './content';
import { ModalHeading } from './heading';
import { ModalFooter } from './footer';
export function Modal({ children, className, onClose }) {
    return (_jsxs(ModalRoot, { onClose: onClose, content: children, children: [_jsx(ModalBackdrop, {}), _jsx(ModalPanel, { className: className })] }));
}
Modal.Root = ModalRoot;
Modal.Backdrop = ModalBackdrop;
Modal.Panel = ModalPanel;
Modal.Header = ModalHeader;
Modal.Content = ModalContent;
Modal.Heading = ModalHeading;
Modal.Footer = ModalFooter;
